import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img alt=""
                                                                                     src={require('@images/greendot.jpg')}/>HELPFUL
                                                HINTS
                                            </div>
                                            <div className="mobile-scroll">
                                                <div className="uiheading">
                                                </div>
                                                <div className="uiheading">
                                                </div>
                                                <div className="uiheading">
                                                </div>
                                                <div className="uiheading">
                                                </div>
                                                <div className="uiheading">
                                                </div>
                                                <div className="uiheading">
                                                </div>
                                                <div className="uiheading">
                                                </div>
                                                <div className="uiheading">
                                                </div>
                                                <div className="uiheading">
                                                </div>
                                                <table width="100%" cellSpacing="0" cellPadding="0"
                                                       border="0"
                                                       className="ilead_v_sport uiheading ilead_v_sport_new_task">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" valign="top" align="left"
                                                            className="green_curve">Identification
                                                        </th>
                                                        <th width="20%" valign="top" align="left">Key points
                                                            for review
                                                        </th>
                                                        <th width="20%" valign="top"
                                                            align="left">Consultation
                                                        </th>
                                                        <th width="20%" valign="top" align="left"
                                                            className=" green_curve1">Key points for review
                                                        </th>
                                                    </tr>

                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>What is wrong?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="WhatIsWrong"
                                                                          value={this.props.pageData?.WhatIsWrong}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Who has been affected
                                                            by the process?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Was the problem brought
                                                            to your attention or did you notice it?</p></td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>How far through the
                                                            process is it?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="HowFarThroughTheProcessIsIt"
                                                                          value={this.props.pageData?.HowFarThroughTheProcessIsIt}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Who would be affected
                                                            by the improvement?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>An issue at the
                                                            beginning impacts those further along the
                                                            process.</p></td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Is it the whole
                                                            process?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="IsItTheWholeProcess"
                                                                          value={this.props.pageData?.IsItTheWholeProcess}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>How widespread has the
                                                            problem been?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>How many complaints
                                                            have you had?</p></td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Is there a training
                                                            need?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="IsThereATrainingNeed"
                                                                          value={this.props.pageData?.IsThereATrainingNeed}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Are all people
                                                            following the process correctly?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Informal chats can
                                                            highlight information that might come out as
                                                            part of a focus group session (people do not
                                                            want to look foolish in front of their
                                                            peers).</p></td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Is the problem with the
                                                            process caused by someone else further along the
                                                            line?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="IsTheProblemWithTheProcess"
                                                                          value={this.props.pageData?.IsTheProblemWithTheProcess}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>What do people feel the
                                                            solution is?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Were any suggestions
                                                            helpful?</p></td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>What is the impact of
                                                            the problem?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="WhatIsTheImpactOfTheProblem"
                                                                          value={this.props.pageData?.WhatIsTheImpactOfTheProblem}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Is the solution a
                                                            simple fix or does it involve a complete
                                                            reappraisal of the process?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Fingers crossed for a
                                                            simple fix.</p></td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Who is responsible for
                                                            this process?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="WhoIsResponsibleForThisProcess"
                                                                          value={this.props.pageData?.WhoIsResponsibleForThisProcess}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Does this require a
                                                            completely new process or just an
                                                            improvement?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>What would be needed to
                                                            justify a completely new process?</p></td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>How widespread is the
                                                            issue?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="HowWidespreadIsTheIssue"
                                                                          value={this.props.pageData?.HowWidespreadIsTheIssue}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p></p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p></p></td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p>Is this a process issue
                                                            or is it a training issue?</p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen">
                                                            <div className="textarealargebox"
                                                                 style={{height: '74px'}}>
                                                                <textarea className="width-bottom"
                                                                          rows="3"
                                                                          cols="10"
                                                                          name="IsThisAProcessIssueOrIsItATrainingIssue"
                                                                          value={this.props.pageData?.IsThisAProcessIssueOrIsItATrainingIssue}
                                                                          onChange={this.props.handleChangePageData}/>
                                                            </div>
                                                        </td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p></p></td>
                                                        <td width="20%" valign="top" align="left"
                                                            className="darkgreen"><p></p></td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="uiheading">
                                            </div>
                                            <div className="uiheading">
                                            </div>
                                            <table width="100%" cellSpacing="0" cellPadding="0" border="0"
                                                   className="ilead_v_sport round roundone uiheading ilead_v_sport_center">
                                                <tbody>
                                                <tr>
                                                    <th width="20%" valign="top" align="left"
                                                        className="green_curve">Implementation
                                                    </th>
                                                    <th width="20%" valign="top" align="left"
                                                        className="green_curve1">Key points for review
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="20%" valign="top" align="left"
                                                        className="lightgreen"><p>Ensure that the person
                                                        with the most comprehensive knowledge of the process
                                                        has the decision making power and the time to change
                                                        things. </p></td>
                                                    <td width="20%" valign="top" align="left"
                                                        className="lightgreen"><p>Is the key person able to
                                                        do this – are there time constraints? How much of a
                                                        priority is it?</p></td>

                                                </tr>
                                                <tr>
                                                    <td width="20%" valign="top" align="left"
                                                        className="darkgreen"><p>Decide the best course of
                                                        action and investigate how to implement it.</p></td>
                                                    <td width="20%" valign="top" align="left"
                                                        className="darkgreen"><p>This should come out from
                                                        the consultation phase, as should the identification
                                                        of the key person for the process. An action
                                                        plan/timetable would need to be prepared for any
                                                        significant changes – did this happen?</p></td>

                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page7')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}